import { msg } from "@lingui/core/macro";
import type { I18n, MessageDescriptor } from "@lingui/core";

import { type ChildTaskStatus, type WorkLogEntry } from "../../session-logic";

export type TaskDisplayStatus = ChildTaskStatus | NonNullable<WorkLogEntry["taskStatus"]>;

const TASK_STATUS_LABELS: Record<TaskDisplayStatus, MessageDescriptor> = {
  running: msg`running`,
  working: msg`working`,
  finished: msg`finished`,
  failed: msg`failed`,
  stopped: msg`stopped`,
};

export function taskStatusLabel(i18n: I18n, status: TaskDisplayStatus): string {
  return i18n._(TASK_STATUS_LABELS[status]);
}
